import React, { useState, useEffect, useCallback, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  Tabs,
  Tab,
  CircularProgress,
  Breadcrumbs,
  Tooltip,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import {
  ChatBubble as ChatIcon,
  ArrowForwardRounded as ForwardIcon,
  CancelPresentationRounded as CloseIcon,
} from '@material-ui/icons'

import { setUndockData } from '../../../redux/undock/actions'
import Typography from '../../atoms/display/typography'
import Icon from '../../atoms/display/icon'
import HistoryData from './historyData'
import HistoryNotes from './historyNotes'

import useStyles from './dataStyle'
import IconButton from '../../atoms/inputs/iconButton'
import ChatTransfer from '../dialogs/chatTransfer'
import {
  setConversations,
  deleteConversations,
} from '../../../redux/conversations/actions'
import Clock from '../../atoms/display/clock'

import { setActiveConversation } from '../../../redux/activeConversation/actions'
import ChatClose from '../dialogs/chatClose'
import { updateGeneralInfo } from '../../../redux/generalInformation/actions'

const Data = ({ ticket = null }) => {
  const undock = useSelector((state) => state.undock)
  const activeAttendanceButtons = ['telefone']

  const defaultStatus = {
    loading: false,
    success: false,
    error: false,
    message: '',
  }

  const { t } = useTranslation()
  let useStylesParams = {
    undock: undock,
  }
  const classes = useStyles(useStylesParams)
  const theme = useTheme()
  const dispatch = useDispatch()

  const activeConversation = undock.data
    ? undock.activeConversation
    : useSelector((state) => state.activeConversation)
  const history = useSelector((state) => state.history)
  const conversations = undock.data
    ? undock.conversations
    : useSelector((state) => state.conversations)
  const consumer = undock.data
    ? undock.conversations[activeConversation]?.consumer
    : useSelector(
        (state) =>
          state.conversations.conversations[activeConversation]?.consumer
      )
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )
  const generalInfo = useSelector(
    (state) => state.generalInformation?.conversations?.[activeConversation]
  )
  const user = useSelector((state) => state.user)

  const widgets = useSelector((state) => state.widgets)
  const [emptySpace, setEmptySpace] = useState(false)
  const [status, setStatus] = useState({ get: defaultStatus })
  const [currentTab, setCurrentTab] = useState(0)
  const [chatTransferDialog, setChatTransferDialog] = useState(false)
  const [openCloseAlert, setOpenCloseAlert] = useState(false)

  const handleTabChange = useCallback((event, value) => {
    setCurrentTab(value)
  }, [])

  const renderBreadcrumbs = () => {
    const skillId =
      history?.conversations?.[consumer?.id]?.[activeConversation]?.skillId ??
      conversations?.conversations?.[activeConversation]?.skillId

    const availableWidgets = widgets?.conversations?.[activeConversation]
    const id = widgets?.list?.find((el) => el.name === 'Usabilidade')?.id

    // TODO: get this name through API when CRUD is implemented
    const usability = availableWidgets?.find((el) => el.id === id)
    const breadcrumb = usability?.data?.breadcrumbs?.split(' > ')

    return (
      <div style={{ paddingTop: 15 }}>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          {breadcrumb?.map((item, key) => {
            return key < breadcrumb.length - 1 ? (
              <Typography color="inherit">{item}</Typography>
            ) : (
              <Typography color="textPrimary">{item}</Typography>
            )
          })}
        </Breadcrumbs>
      </div>
    )
  }

  const renderContentTabs = () => {
    let html
    if (currentTab === 0) {
      html = <HistoryData chatId={activeConversation} ticket={ticket} />
    }
    if (currentTab === 1) {
      html = <HistoryNotes chatId={activeConversation} />
    }
    return html
  }

  useEffect(() => {
    if (undock?.data) {
      const interval = setInterval(() => {
        var ac = JSON.parse(localStorage.getItem('state'))?.undock
          ?.activeConversation
        if (!ac) {
          setEmptySpace(true)
        } else {
          setEmptySpace(false)
        }
      }, 500)
      return () => clearInterval(interval)
    }
  }, [])

  const launchUndock = () => {
    dispatch(setUndockData(true))
    var panel = '/undock/data'
    var width = 500
    var height = 800
    var left = (window.screen.width - width) / 4
    var top = (window.screen.height - height) / 2
    var params = 'width=' + width + ', height=' + height
    params += ', top=' + top + ', left=' + left
    params += ', directories=no'
    params += ', location=no'
    params += ', menubar=no'
    params += ', resizable=yes'
    params += ', scrollbars=no'
    params += ', status=no'
    params += ', toolbar=no'
    var panelData = window.open(panel, '', params)    
  }

  const renderEmptySpace = () => {
    return (
      <>
        <div className={classes.emptySpace}>
          <Icon>
            <ChatIcon />
          </Icon>
          <Typography variant="body1" style={{ marginTop: 10 }}>
            {t('commons.serviceTools')}
          </Typography>
          <Typography
            variant="body2"
            style={{ color: theme.palette.highlightSearchActive }}
          >
            {t('commons.emptyActiveConversation')}
          </Typography>
        </div>
      </>
    )
  }

  const renderAttendanceActions = useCallback(() => {
    return (
      <>
        {conversation &&
          activeAttendanceButtons.includes(conversation.channel) &&
          conversation.status != 'closed' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flexDirection: 'row',
              }}
            >
              <Clock
                chatId={activeConversation}
                endTime={conversation?.end}
                assignedTime={conversation?.assignedTime}
              />
              <div style={{ width: 10 }} />
              <Tooltip placement="bottom" title={t('tooltip.transfer')}>
                <div>
                  <IconButton
                    color="primary"
                    onClick={() => setChatTransferDialog(true)}
                  >
                    <ForwardIcon
                      style={{ color: theme.palette.primary.main }}
                    />
                  </IconButton>
                </div>
              </Tooltip>
              <div style={{ width: 10 }} />
              <Tooltip placement="bottom" title={t('tooltip.close')}>
                <div>
                  <IconButton
                    color="primary"
                    onClick={() => setOpenCloseAlert(true)}
                  >
                    <CloseIcon style={{ color: theme.palette.primary.main }} />
                  </IconButton>
                </div>
              </Tooltip>
              {chatTransferDialog && (
                <ChatTransfer
                  open={chatTransferDialog}
                  setOpen={setChatTransferDialog}
                  chatId={activeConversation}
                  onSubmit={(e) => {
                    if (e?.status?.success) {
                      // update store
                      if (conversation) {
                        dispatch(deleteConversations(activeConversation))
                        dispatch(setActiveConversation(null))
                      }
                    }
                  }}
                />
              )}
            </div>
          )}
        {openCloseAlert && (
          <ChatClose
            open={openCloseAlert}
            setOpen={setOpenCloseAlert}
            onSubmit={(e) => {
              if (e?.status?.success && e?.status?.status) {
                let end = new Date()
                let assignedTime = null;

                if(e?.conversationTA?.endConversation){
                  end = new Date(`${e?.conversationTA?.endConversation}`);
                }

                if(e?.conversationTA?.startConversation){
                  assignedTime = new Date(`${e?.conversationTA?.startConversation}`);
                }

                // Update general information attributes
                if (generalInfo) {
                  generalInfo.chatInfo.status = e?.status?.status
                  generalInfo.chatInfo.end = end
                  generalInfo.chatInfo.closedBy = user.name

                  const obj = {
                    chatId: activeConversation,
                    data: generalInfo,
                  }
                  dispatch(updateGeneralInfo(obj))
                }

                // Update conversation attributes
                if (conversation) {
                  conversation.status = e?.status?.status
                  conversation.end = end
                  conversation.assignedTime = assignedTime ? assignedTime : conversation.assignedTime;
                  dispatch(setConversations(conversation))
                  dispatch(setActiveConversation(null))
                }
              }
            }}
          />
        )}
      </>
    )
  }, [activeConversation, conversation, chatTransferDialog, openCloseAlert])

  const renderContent = () => {
    if (ticket) {
      return (
        <>
          <div className={classes.root}>
            <div className={classes.right}>
              <div className={classes.rightHeader}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Icon text={t('commons.serviceTools')}>
                    {status.get.loading ? (
                      <CircularProgress size={24} />
                    ) : (
                      <ChatIcon />
                    )}
                  </Icon>
                </div>
                <div style={{ height: 15 }} />
                <Tabs
                  value={currentTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  variant="fullWidth"
                  textColor="primary"
                >
                  <Tab label={t('commons.data')} />
                  <Tab label={t('commons.notes')} />
                </Tabs>
              </div>
              {renderContentTabs()}
            </div>
          </div>
        </>
      )
    }
    return (
      <>
        <div className={classes.root}>
          <div className={classes.right}>
            <div className={classes.rightHeader}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Icon text={t('commons.serviceTools')}>
                  {status.get.loading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <ChatIcon />
                  )}
                </Icon>
                {/* {!undock?.data && (
                  <Tooltip placement="bottom" title={t('buttons.launch')}>
                    <div>
                      <IconButton color="primary">
                        <LaunchIcon
                          style={{ color: theme.palette.primary.main }}
                          onClick={() => {
                            launchUndock()
                          }}
                        />
                      </IconButton>
                    </div>
                  </Tooltip>
                )} */}
                {renderAttendanceActions()}
              </div>
              <div style={{ height: 15 }} />
              <Tabs
                value={currentTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                variant="fullWidth"
                textColor="primary"
              >
                <Tab label={t('commons.data')} />
                <Tab label={t('commons.notes')} />
              </Tabs>
              {renderBreadcrumbs()}
            </div>
            {renderContentTabs()}
          </div>
        </div>
      </>
    )
  }

  return emptySpace ? renderEmptySpace() : renderContent()
}

export default memo(Data)
